import { faCirclePhone, faEnvelopeCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentContact } from 'customHooks/useCurrentContact';

const CompanyPrimaryInfoActions = () => {
    const { data: contact } = useCurrentContact();
    return (
        <div className={'flex items-center gap-4 sm:hidden'}>
            {!!contact.primary_email && (
                <a href={`mailto:${contact.primary_email}`}>
                    <FontAwesomeIcon
                        className={'text-blue-500'}
                        size={'2x'}
                        icon={faEnvelopeCircle}
                    />
                </a>
            )}
            {!!contact.primary_phone && (
                <a href={`tel:${contact.primary_phone}`}>
                    <FontAwesomeIcon className={'text-blue-500'} size={'2x'} icon={faCirclePhone} />
                    <span className="sr-only">Call {contact.primary_phone}</span>
                </a>
            )}
        </div>
    );
};

export { CompanyPrimaryInfoActions };
